import React from 'react';

/** Toggle compartilhado pelas abas Números e Uso: o usuário `admin` é a conta do
 *  suporte e fica FORA dos agregados por default — cada atendimento entrava
 *  como se fosse operação do cliente. É pelo LOGIN, não pelo perfil (o dono do
 *  cliente também é ADMIN e conta). Só afeta os agregados; a lista de Eventos
 *  (trilha forense) mostra todo mundo, sempre. */
export const ToggleIncluirAdmin: React.FC<{ valor: boolean; onChange: (v: boolean) => void }> = ({ valor, onChange }) => (
  <label
    className="flex cursor-pointer items-center gap-1.5 text-xs text-tx-2"
    title="O usuário admin é a conta do suporte e distorce o uso real. Desmarcado, os números são só dos usuários do cliente."
  >
    <input
      type="checkbox"
      checked={valor}
      onChange={(e) => onChange(e.target.checked)}
      className="h-3.5 w-3.5 rounded border-line"
    />
    Incluir usuário admin
  </label>
);
